import styled from 'styled-components';

export const SectionTitle = styled.h2`
  margin: 0 0 12px;
  border-bottom: 2px solid #0078d7;
  padding-bottom: 5px;
  font-size: 1rem;
  font-weight: bold;
`;

export const SubsectionTitle = styled.h3`
  margin: 5px 0;
  color: #0078d7;
  font-size: 0.95rem;
`;

export const Block = styled.section`
  margin-bottom: 20px;
`;

export const Link = styled.a`
  color: #0078d7;
  text-decoration: underline;
  word-break: break-word;

  &:hover,
  &:focus-visible {
    text-decoration: none;
    outline: 2px solid #0078d7;
    outline-offset: 2px;
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Avatar = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
`;

export const ProfileFields = styled.div`
  flex: 1;
  min-width: min(100%, 200px);
`;
